import { IconButton, Menu, menuClasses, MenuItem, Typography } from '@mui/material'
import { FC, MouseEventHandler, useState } from 'react'
import { ReplyScheduleDTO } from '../../../api/gen/base'
import DotsVerticalIcon from '../../../assets/icons/DotsVertical.svg'
import PenIcon from '../../../assets/icons/Pen.svg?react'
import TrashIcon from '../../../assets/icons/Trash.svg?react'

type Props = {
    request: ReplyScheduleDTO
    onEdit: (request: ReplyScheduleDTO) => void
    onDelete: (replyScheduleId: number) => void
}

export const RegularRequestActionsMenu: FC<Props> = ({ request, onEdit, onDelete }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

    const isOpenMenu = Boolean(anchorEl)

    const handleOpenMenu: MouseEventHandler<HTMLButtonElement> = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const menuItems = [
        {
            key: '1',
            Icon: PenIcon,
            label: 'Редактировать',
            onClick: () => onEdit(request),
            color: '#5A5F72',
        },
        {
            key: '2',
            Icon: TrashIcon,
            label: 'Удалить',
            onClick: () => onDelete(request.id),
            color: '#CA1616',
        },
    ]

    return (
        <>
            <Menu
                anchorEl={anchorEl}
                open={isOpenMenu}
                onClose={handleCloseMenu}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    [`.${menuClasses.paper}`]: {
                        width: 180,
                        borderRadius: '8px',
                        overflow: 'hidden',
                    },
                    [`.${menuClasses.list}`]: {
                        p: '4px',
                        maxHeight: 360,
                        overflow: 'auto',
                    },
                }}>
                {menuItems.map(({ key, label, Icon, color, onClick }) => (
                    <MenuItem
                        key={key}
                        onClick={() => {
                            onClick()
                            handleCloseMenu?.()
                        }}
                        sx={{
                            minHeight: 'unset',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 1,
                            p: '10px 16px 10px 12px',
                            color,
                            borderRadius: '24px',

                            ':hover': {
                                backgroundColor: '#F4F4F6',
                                borderRadius: '100px',
                            },
                        }}>
                        <Typography
                            variant="body2"
                            color={color}
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 500,
                            }}>
                            {label}
                        </Typography>
                        <Icon color={color} />
                    </MenuItem>
                ))}
            </Menu>
            <IconButton size="large" sx={{ ml: 'auto' }} onClick={handleOpenMenu}>
                <DotsVerticalIcon />
            </IconButton>
        </>
    )
}
